
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/age-groups",
      function () {
        return require("private-next-pages/age-groups.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/age-groups"])
      });
    }
  